import React, { useEffect,useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AssignCenterHead = ({ show, onClose, selectedBranch, refresh  }) => {
       const [selectedOption, setSelectedOption] = useState(null);
       const [staffOptions, setStaffOptions] = useState([]);
       const [selectedStaff, setSelectedStaff] = useState(null);
       const [validationError, setValidationError] = useState(null);
       const [error, setError] = useState(null);
       const [existingManagebranch, setExistingManagebranch] = useState([]);
       const baseURL = process.env.REACT_APP_API_BASE_URL;

        useEffect(() => {
            if (show && selectedBranch) {
                axios.get(`${baseURL}/managebranch/${selectedBranch.sno}/managers`)
                    .then(response => {
                        const staffOptions = response.data.data.map(staff => ({
                            value: staff.sno,
                            label: staff.employee_name,
                            email: staff.mail_id,
                            phone: staff.phone_no,
                        }));

                        setStaffOptions(staffOptions);

                        const existing = selectedBranch.assign_manager?.[0];
                        if (existing) {
                            const existingStaff = staffOptions.find(s => s.value === existing.sno);
                            if (existingStaff) setSelectedStaff(existingStaff);
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching manager data", error);
                    });
            }
        }, [show, selectedBranch]);

        useEffect(() => {
            // console.log('Child sees selectedBranch:', selectedBranch);
        }, [selectedBranch]);

    const handleAssignManager = async () => {
        if (!selectedStaff) {
            setValidationError('This field is required');
            return;
        }

        try {
            const payload = {
                assign_manager: [
                {
                sno: selectedStaff.value,
                employee_name: selectedStaff.label,
                phone_no: String(selectedStaff.phone),
                mail_id: selectedStaff.email,
                }
            ]
            };

            // Make sure selectedBranch is passed correctly and represents the branch ID or name
            await axios.post(`${baseURL}/managebranch/${selectedBranch.sno}/assignmanager`, payload); 
            // window.location.reload();
            toast.success("Manager Assigned Successfully!");
            setError(null); // Clear any previous errors
            refresh();
            onClose();      // Close modal on success
        } catch (error) {
            console.error('Error assigning manager:', error);
            if (error.response && error.response.data.errors) {
                setError(JSON.stringify(error.response.data.errors)); // Display validation errors
            } else {
                setError('Failed to assign manager. Please try again.');
            }
            toast.error("Manager Assigning Failed");
        }
    };

    const handleSelectChange = (option) => {
        setSelectedOption(option);
        if (option) {
            setValidationError(null);
        }
    };

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Assign Manager</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Incharge Person<span className="required">*</span></label>
                            <Select placeholder={'Select Incharge Person'}
                                value={selectedStaff}
                                onChange={(option) => {
                                    setSelectedStaff(option);
                                    setValidationError(null);
                                }}
                                options={staffOptions}
                            />
                            {validationError && <div className="text-danger mt-1">{validationError}</div>}
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Mobile No" value={selectedStaff?.phone || ''} readOnly/>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Email ID<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Email ID" value={selectedStaff?.email || ''} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleAssignManager}>Assign Manager <i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AssignCenterHead;
